import { request } from '@/api/client';
import type {
  CreditFeedbackStatus,
  SubmitCreditFeedbackRequest,
  SubmitCreditFeedbackResponse,
} from '@/types/creditFeedback';

/** Low-credits feedback popover — eligibility check and submission. */
export const creditFeedbackService = {
  getStatus: (signal?: AbortSignal): Promise<CreditFeedbackStatus> =>
    request<CreditFeedbackStatus>('/credit-feedback/status', {
      method: 'GET',
      auth: true,
      ...(signal ? { signal } : {}),
    }),

  submit: (data: SubmitCreditFeedbackRequest): Promise<SubmitCreditFeedbackResponse> =>
    request<SubmitCreditFeedbackResponse>('/credit-feedback/submit', {
      method: 'POST',
      auth: true,
      body: JSON.stringify(data),
    }),
};
